module.exports = __webpack_public_path__ + "img/youporn.3e03be2.png";